// File: components/LocationMultiplier.jsx
import React, {useState} from 'react';
import useLocalization from '../hooks/useLocalization';

const LocationMultiplier = ({
    locationMultiplier,
    setLocationMultiplier,
    isVisible,
    locationMultiplierInfo // Can still accept this prop but will use localization if not provided
}) => {
    const translations = useLocalization();
    const [showInfo, setShowInfo] = useState(false);

    // Use the provided props or fall back to translations
    const info = locationMultiplierInfo || translations.locationMultiplier;

    if (!isVisible) return null;

    return (
        <div className="mb-4">
            <div className="flex items-center mb-1">
                <h3 className="font-medium">{info.title}</h3>
                <button
                    className="ml-2 text-blue-500 text-sm"
                    onClick={() => setShowInfo(!showInfo)}
                >
                    {showInfo ? info.hideInfoLabel : info.showInfoLabel}
                </button>
            </div>

            {showInfo && (
                <div className="bg-blue-50 p-3 rounded mb-3 text-sm">
                    <p>{info.description}</p>
                    <p className="mt-2">
                        <a
                            href={info.costOfLivingLink.url}
                            className="text-blue-600 underline font-medium"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {info.costOfLivingLink.text}
                        </a>
                    </p>
                </div>
            )}

            <div className="flex items-center">
                <input
                    type="number"
                    value={locationMultiplier}
                    onChange={(e) => setLocationMultiplier(Number(e.target.value))}
                    className="w-24 p-2 border rounded mr-2"
                    min="1"
                    step="0.01"
                />
                <span className="text-sm text-gray-600">
                    {info.multiplierSuffix}
                </span>
            </div>
        </div>
    );
};

export default LocationMultiplier;